import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DoctorService } from '../../services/doctor.service';
import { PatientService } from '../../services/patient.service';
import { ErrorPanelService } from '../../services/error-panel.service';
import { Reminders, TodayAppointments } from '../../models/patient-model';
import { CalendarUtilsService } from './calendar-utils.service';

@Injectable({
  providedIn: 'root',
})
export class TodayAppointmentsService {
  todayAppointments: TodayAppointments[] = [];
  remindersNextPatient: Reminders[] = [];
  remindersNotCompleted: number = 0;
  nextPatientId: string = '';
  nextPatientName: string = '';
  nextPatientSurname: string = '';
  nextPatientFullName: string = '';

  constructor(
    private router: Router,
    private doctorService: DoctorService,
    private patientService: PatientService,
    private errorPanelService: ErrorPanelService,
    private calendarUtils: CalendarUtilsService
  ) {}

  getTodayAppointments() {
    this.todayAppointments = [];
    this.doctorService.getTodayAppointments().subscribe({
      next: (data: TodayAppointments[]) => {
        data.map((appointment: TodayAppointments) => {
          this.todayAppointments.push(appointment);
        });
        if (this.todayAppointments.length > 0) {
          this.nextPatientId = this.todayAppointments[0].patient_id;
          this.nextPatientName = this.todayAppointments[0].patient_first_name;
          this.nextPatientSurname = this.todayAppointments[0].patient_last_name;
          this.nextPatientFullName =
            this.nextPatientName + ' ' + this.nextPatientSurname;
          this.getNextPatientReminders();
        }
      },
      error: (err) => {
        console.error('Errore nel recuperare gli appuntamenti di oggi', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel caricare gli appuntamenti odierni'
        );
      },
    });
  }

  getNextPatientReminders() {
    this.patientService.getReminders(this.nextPatientId).subscribe({
      next: (data) => {
        this.remindersNextPatient = [];
        this.remindersNotCompleted = 0;
        data.map((reminder: any) => {
          var tempReminer: Reminders = {
            text: reminder.description,
            completed: reminder.completed,
          };
          if (!tempReminer.completed) {
            this.remindersNotCompleted++;
            this.remindersNextPatient.push(tempReminer);
          }
        });
      },
      error: (err) => {
        console.error('Errore nel recuperare i promemoria del paziente', err);
        this.errorPanelService.showErrorSnackBar(
          'Errore nel caricare i promemoria del paziente'
        );
      },
    });
  }

  changePatient(appointment: TodayAppointments) {
    this.nextPatientId = appointment.patient_id;
    this.nextPatientName = appointment.patient_first_name;
    this.nextPatientSurname = appointment.patient_last_name;
    this.nextPatientFullName =
      this.nextPatientName + ' ' + this.nextPatientSurname;
    this.getNextPatientReminders();
  }

  navigateToPatientPage() {
    this.router.navigate([`/pazienti/${this.nextPatientId}`]);
  }

  navigateToAiPatientPage() {
    this.router.navigate([
      `/pazienti/${this.nextPatientId}/funzioni-ai/sintesi-complessiva`,
    ]);
  }

  navigateToLastAppointmentSummaryPage(dbAppointments: any[]) {
    let nextPatientAppointments = dbAppointments.filter(
      (app) => app.patient_id === this.nextPatientId
    );

    // Find the most recent past appointment
    const now = new Date();
    const lastAppointment = nextPatientAppointments
      .map((app) => ({
        ...app,
        dateTime: this.calendarUtils.combineDateTime(app.date, app.start_time),
      }))
      .filter((app) => app.dateTime < now)
      .sort((a, b) => b.dateTime.getTime() - a.dateTime.getTime())[0];

    const lastAppointmentId = lastAppointment?.id;

    this.router.navigate([
      `/pazienti/${this.nextPatientId}/appointments/${lastAppointmentId}/ai/summary`,
    ]);
  }
}
